import styled from '@emotion/styled';
import { MarketplaceTypeLabel } from 'components/cards/listing/UniversalCard/styled';
import { H3, Text } from 'ds/components/typography';
import { Link } from 'components/link';
import { BookmarkIconWrapper } from 'components/favorites/styled';


export const CardWrapper = styled(Link)<{ isMapPreview: boolean }>`
  border-radius: ${({ theme, isMapPreview }) => isMapPreview ? theme.borderRadius.small : theme.borderRadius.tiny};
  overflow: hidden;
  max-width: ${({ isMapPreview }) => isMapPreview ? '214px' : '280px'};
  background-color: ${({ theme }) => theme.colors.neutrals.white};
  text-decoration: none;
  ${({ theme, isMapPreview }) => isMapPreview ? `
    box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.10), 0px 4px 12px 0px rgba(0, 0, 0, 0.15);
    ` : `
    padding: ${theme.spacing(1)} ${theme.spacing(1)} ${theme.spacing(3)};
    :hover {
      box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.10), 0px 4px 12px 0px rgba(0, 0, 0, 0.15);
    }
  `}
  ${({ theme }) => theme.media.showAt({ at: 1 })`
    width: 100%;
    max-width: 100%;
    border-radius: ${theme.borderRadius.small} ${theme.borderRadius.small} 0 0;
  `}
  ${({ theme, isMapPreview }) => !isMapPreview && theme.media.showAt({ to: 2 })`
    && {
      box-shadow: none;
    }
  `}
`;

export const ImgWrapper = styled.div<{ isMapPreview: boolean }>`
  position: relative;
  ${({ theme, isMapPreview }) => isMapPreview ? `
      border-radius: ${theme.borderRadius.small} ${theme.borderRadius.small} 0 0;
      height: 128px;
    ` : `
      border-radius: ${theme.borderRadius.tiny};
      height: 164px;
  `};
  overflow: hidden;
  ${({ theme }) => theme.media.showAt({ at: 1 })`
    height: 176px;
  `}
`;

export const Image = styled.div`
  position: absolute;
  inset: 0;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const PlaceholderWrapper = styled.div<{ isMapPreview: boolean }>`
  position: absolute;
  inset: 0;
  border: 1px solid ${({ theme }) => theme.colors.neutrals.grey8};
  border-radius: ${({ theme }) => theme.borderRadius.tiny};
  overflow: hidden;
  svg {
    width: 100%;
    height: 100%;
  }
  ${({ theme, isMapPreview }) => isMapPreview ? `
    border-radius: ${theme.borderRadius.tiny} ${theme.borderRadius.tiny} 0 0;
  ` : ''}
  ${({ theme, isMapPreview }) => isMapPreview && theme.media.showAt({ at: 1 })`
    border-left: 0 none;
    border-right: 0 none;
  `}
`;

export const MarketplaceTypeLabelWrapper = styled(MarketplaceTypeLabel)`
  position: absolute;
  top: 16px;
  right: 16px;
  background-color: ${({ theme, isCommercial }) => isCommercial ? theme.colors.brand.secondary : theme.colors.brand.mintieWhite};
  margin: 0;
  font-family: NovemberHebrew;
`;

export const InfoWrapper = styled.div`
  padding: ${({ theme }) => `${theme.spacing(1)} ${theme.spacing(0.5)}`};
  color: ${({ theme }) => theme.colors.neutrals.grey1};
  ${({ theme }) => theme.media.showAt({ at: 1 })`
    padding: ${theme.spacing(1)};
  `}
`;

export const Price = styled(H3)``;

export const OtherInfo = styled(Text)`
  margin-top: ${({ theme }) => theme.spacing(0.5)};
`;

export const PropertyType = styled(Text.withComponent('span'))``;

export const SaveWrapper = styled(BookmarkIconWrapper)`
  position: absolute;
  top: 16px;
  left: 16px;
`;
